const cleanData = (values) => {
  let filterArray = ["_", "__typename"];
  let data = values;
  filterArray.map((x) => {
    delete data[x];
    return data;
  });
  if (!values["files"]) {
    values["files"] = [];
  }

  // Clean file objects
  if (
    values["supervisedRecruitmentAttached"] &&
    typeof values["supervisedRecruitmentAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["supervisedRecruitmentAttached"]
    );
    values["supervisedRecruitmentAttached"] = "YES";
  }
  if (
    values["playerContractAttached"] &&
    typeof values["playerContractAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["playerContractAttached"]);
    values["playerContractAttached"] = "YES";
  }
  if (
    values["offSeasonAttached"] &&
    typeof values["offSeasonAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["offSeasonAttached"]);
    values["offSeasonAttached"] = "YES";
  }
  if (
    values["unionLetterAttached"] &&
    typeof values["unionLetterAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["unionLetterAttached"]);
    values["unionLetterAttached"] = "YES";
  }
  if (
    values["professionalAssociationAttached"] &&
    typeof values["professionalAssociationAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["professionalAssociationAttached"]
    );
    values["professionalAssociationAttached"] = "YES";
  }
  if (
    values["teamRevenueAttached"] &&
    typeof values["teamRevenueAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(values["teamRevenueAttached"]);
    values["teamRevenueAttached"] = "YES";
  }
  if (
    values["playerStatisticsAttached"] &&
    typeof values["playerStatisticsAttached"] === "object"
  ) {
    values["files"] = values["files"].concat(
      values["playerStatisticsAttached"]
    );
    values["playerStatisticsAttached"] = "YES";
  }

  // Clean file fields
  if (values["files"]) {
    values["files"].filter(
      (file) => file.machine_name === "supervisedRecruitmentAttached"
    ).length > 0
      ? (data["supervisedRecruitmentAttached"] = "YES")
      : (data["supervisedRecruitmentAttached"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "playerContractAttached"
    ).length > 0
      ? (data["playerContractAttached"] = "YES")
      : (data["playerContractAttached"] = "NO");
    values["files"].filter((file) => file.machine_name === "offSeasonAttached")
      .length > 0
      ? (data["offSeasonAttached"] = "YES")
      : (data["offSeasonAttached"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "unionLetterAttached"
    ).length > 0
      ? (data["unionLetterAttached"] = "YES")
      : (data["unionLetterAttached"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "professionalAssociationAttached"
    ).length > 0
      ? (data["professionalAssociationAttached"] = "YES")
      : (data["professionalAssociationAttached"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "teamRevenueAttached"
    ).length > 0
      ? (data["teamRevenueAttached"] = "YES")
      : (data["teamRevenueAttached"] = "NO");
    values["files"].filter(
      (file) => file.machine_name === "playerStatisticsAttached"
    ).length > 0
      ? (data["playerStatisticsAttached"] = "YES")
      : (data["playerStatisticsAttached"] = "NO");

    if (values["files"].length > 0) {
      for (let j = 0; j < values["files"].length; j++) {
        data["files"][j].size = data["files"][j].size.toString();
        delete data["files"][j].fileTypes;
        data["files"][j].lastModified =
          data["files"][j].lastModified.toString();
        delete data["files"][j].fileUploadedFrom;
        if (data["files"][j].__typename) {
          delete data["files"][j].__typename;
        }
      }
    }
  }
  return data;
};

export { cleanData };
